import { styled } from '@mui/material';
import { NavLink as Link } from 'react-router-dom';
import { COLORS } from '../../../theme/color';

type NavLinkConProps = {
  $isActive?: boolean;
};

export const NavLinkCon = styled(Link)<NavLinkConProps>`
  width: 100%;
  background-color: ${props => (props.$isActive ? COLORS.MainBlue : COLORS.White)};
  border-radius: ${props => (props.$isActive ? '26px' : '0px')};
  padding: 0.5rem 0.2rem 0.5rem 32px;
  margin: 4px 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  transition: background-color 0.3s ease-in-out;
  text-decoration: none;
  gap: 12px;
  color: ${props => (props.$isActive ? COLORS.White : COLORS.MainBlack)};
  font-weight: 400;
  font-size: 16px;
  margin-bottom: 1rem;
  text-transform: capitalize;

  .navIcon {
    background-color: #f8f7f7;
    width: 2rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.1rem;
    border-radius: 1rem;
    overflow: hidden;
    margin-right: 1rem;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  &:hover {
    background-color: ${COLORS.SecBlue};
  }
`;

// export const active = {
//   backgroundColor: `${COLORS.MainBlue}`,
//   color: '#fff'
// };
